import React from "react";
import aboutHeroImg from "../assets/about.jpg.avif";
import aboutImg from "../assets/logobg.png";
import abt from "../assets/about2.jpg";
import Navbar from "./Navbar";
import Footer from './Footer';

const AboutPage = () => {
  return (
    <>
      <style>{`

        /* ================= HERO ================= */

        .hero {
          position: relative;
          height: 100vh;
          display: flex;
          align-items: center;
          color: white;
        }

        .hero::before {
          content: "";
          position: absolute;
          inset: 0;
          background: url(${aboutHeroImg}) center/cover no-repeat;
        }

        .hero::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            90deg,
            rgba(15, 61, 46, 0.9),
            rgba(15, 61, 46, 0.3)
          );
        }

        .hero-content {
          position: relative;
          z-index: 2;
          margin-left: 80px;
          max-width: 600px;
        }

        .hero h1 {
          font-size: 48px;
          margin-bottom: 20px;
        }

        .hero-btn {
          background: #7ED957;
          padding: 12px 22px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        /* ================= ABOUT ================= */

        .about-firm {
          background: #DCF6C6;
          padding: 80px 20px;
        }

        .about-container {
          max-width: 1200px;
          margin: auto;
          display: flex;
          gap: 60px;
          align-items: center;
        }

        .about-left {
          max-width: 600px;
        }

        .about-left h2 {
          color: #0F3D2E;
          margin-bottom: 15px;
        }

        .about-left p {
          line-height: 1.7;
          color: #333;
        }

        .about-right img {
          width: 400px;
          height: 420px;
          object-fit: cover;
          border-radius: 20px;
        }

        /* ================= EXPERTISE ================= */

        .expertise-section {
          background: #EFFFE1;
          padding: 80px 20px;
        }

        .expertise-container {
          max-width: 1200px;
          margin: auto;
          display: flex;
          align-items: center;
          gap: 60px;
        }

        .expertise-img img {
          width: 480px;
          height: 420px;
          object-fit: cover;
          border-radius: 20px;
        }

        .expertise-content {
          max-width: 550px;
        }

        .tag {
          border: 1px solid #0F3D2E;
          color: #0F3D2E;
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 12px;
          margin-bottom: 15px;
          display: inline-block;
        }

        .expertise-content h2 {
          color: #0F3D2E;
          font-size: 36px;
          margin-bottom: 15px;
        }

        .expertise-content p {
          color: #555;
          margin-bottom: 25px;
        }

        .features {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px 25px;
        }

        .feature {
          display: flex;
          gap: 10px;
          color: #333;
          font-size: 14px;
        }

        .dot {
          width: 20px;
          height: 20px;
          background: #7ED957;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: black;
        }

        /* ================= MILESTONE ================= */

        .milestone-section {
          background: #DCF6C6;
          padding: 100px 20px;
        }

        .milestone-container {
          max-width: 1200px;
          margin: auto;
        }

        .milestone-top h2 {
          color: #0F3D2E;
          font-size: 34px;
          margin-bottom: 50px;
        }

        .grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }

        .card {
          background: #EFFFE1;
          padding: 28px;
          border-radius: 18px;
          box-shadow: 0 10px 25px rgba(0,0,0,0.08);
          transition: all 0.35s ease;
          transform: translateY(0);
          opacity: 0;
          animation: fadeUp 0.6s ease forwards;
        }

        .card:nth-child(1){ animation-delay: 0.1s; }
        .card:nth-child(2){ animation-delay: 0.2s; }
        .card:nth-child(3){ animation-delay: 0.3s; }
        .card:nth-child(4){ animation-delay: 0.4s; }
        .card:nth-child(5){ animation-delay: 0.5s; }
        .card:nth-child(6){ animation-delay: 0.6s; }

        .card:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }

        .card h3 {
          color: #0F3D2E;
          margin-bottom: 12px;
          font-size: 18px;
        }

        .card p,
        .card li {
          color: #444;
          font-size: 14px;
          line-height: 1.6;
        }

        .card ul {
          padding-left: 18px;
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* ================= RESPONSIVE ================= */

        @media (max-width: 900px) {
          .hero-content {
            margin: 20px;
          }

          .hero h1 {
            font-size: 32px;
          }

          .about-container,
          .expertise-container {
            flex-direction: column;
            text-align: center;
          }

          .grid {
            grid-template-columns: 1fr;
          }

          .about-right img,
          .expertise-img img {
            width: 100%;
            height: auto;
          }

          .features {
            grid-template-columns: 1fr;
          }
        }

      `}</style>

      <Navbar />

      {/* HERO */}
      <section className="hero">
        <div className="hero-content">
          <h1>
            Empowering Businesses <br />
            With Smart Tax & Financial Solutions
          </h1>
          <button className="hero-btn">Learn More ↗</button>
        </div>
      </section>

      {/* ABOUT */}
      <section className="about-firm">
        <div className="about-container">
          <div className="about-left">
            <h2>About Us</h2>
            <p>
              We are a technology-led tax advisory firm delivering precision-driven
              compliance, risk intelligence, and strategic tax architecture.
            </p>
            <p>
              Our approach integrates artificial intelligence with domain expertise
              to move beyond routine filings and enable data-backed financial control
              for individuals, founders, and high-net-worth clients.
            </p>
          </div>
          <div className="about-right">
            <img src={aboutImg} alt="" />
          </div>
        </div>
      </section>

      {/* EXPERTISE */}
      <section className="expertise-section">
        <div className="expertise-container">
          <div className="expertise-img">
            <img src={abt} alt="" />
          </div>

          <div className="expertise-content">
            <span className="tag">ABOUT US</span>

            <h2>
              Unlock our expertise to drive <br />
              success across industries.
            </h2>

            <p>
              Leverage our deep industry knowledge and innovative strategies
              to accelerate your business growth.
            </p>

            <div className="features">
              <div className="feature"><span className="dot">✓</span> Measurable proven results</div>
              <div className="feature"><span className="dot">✓</span> Innovative real solutions</div>
              <div className="feature"><span className="dot">✓</span> Customized business strategies</div>
              <div className="feature"><span className="dot">✓</span> Reliable expert guidance</div>
              <div className="feature"><span className="dot">✓</span> Multi-industry expertise</div>
              <div className="feature"><span className="dot">✓</span> Support for long-term growth</div>
            </div>
          </div>
        </div>
      </section>

      {/* MILESTONE */}
      <section className="milestone-section">
        <div className="milestone-container">

          <div className="milestone-top">
            <h2>Key Services & Capabilities</h2>
          </div>

          <div className="grid">

            <div className="card">
              <h3>Continuous Tax Health Tracking</h3>
              <ul>
                <li>liability position</li>
                <li>compliance status</li>
                <li>risk indicators</li>
              </ul>
            </div>

            <div className="card">
              <h3>Integrated Financial Advisory</h3>
              <ul>
                <li>wealth structuring</li>
                <li>capital allocation</li>
                <li>financing decisions</li>
              </ul>
            </div>

            <div className="card">
              <h3>Data Reconciliation</h3>
              <ul>
                <li>AIS</li>
                <li>TIS</li>
                <li>Form 26AS</li>
                <li>broker statements</li>
              </ul>
            </div>

            <div className="card">
              <h3>High-Value Clients</h3>
              <ul>
                <li>confidential workflows</li>
                <li>transaction monitoring</li>
                <li>compliance oversight</li>
              </ul>
            </div>

            <div className="card">
              <h3>Dedicated Advisor</h3>
              <p>Each client gets a dedicated expert.</p>
            </div>

            <div className="card">
              <h3>Always-On Support</h3>
              <p>Accessible for time-sensitive advisory needs.</p>
            </div>

          </div>

        </div>
      </section>
      <Footer/>

    </>
  );
};

export default AboutPage;